import React, { useEffect, useRef, useState } from 'react'
import { bool, func, node, number, object, oneOfType, shape, string } from 'prop-types'
import { loadData } from '@jelly/utils'

export const PAGE_ONE = 1
export const ResultContext = React.createContext()

ResultProvider.propTypes = {
	children: node.isRequired,
	mainContent: object.isRequired,
	generateURL: func.isRequired,
	page: oneOfType([number, string]).isRequired,
	search: object.isRequired,
	tab: string.isRequired,
	tabs: shape({
		label: string,
		queryValue: string,
	}),
	loadMore: bool.isRequired,
}

/**
 * This is the Generic Provider
 * Contains all the context values used throughout the ResultList and containers
 * Including the logic for fetching new data from Swiftype, handles tab switching and pagination
 */
function ResultProvider({ children, mainContent, generateURL, page, search: searchData, tab, tabs, loadMore }) {
	const [results, setResults] = useState({
		[tab]: mainContent,
	})
	const [search, setSearch] = useState(searchData)

	const [isLoading, setIsLoading] = useState(false)

	const isFirstRender = useRef(true)

	const handleLoadMoreResults = () => {
		setIsLoading(true)

		loadData(generateURL(results[tab].skipInterval)).then(({ mainContent }) => {
			setResults((results) => {
				const currentTab = results[tab] ? results[tab] : { content: [] }
				return {
					...results,
					[tab]: {
						content: [...currentTab.content, ...mainContent.content],
						loadMore: mainContent.loadMore,
						skipInterval: mainContent.skipInterval,
					},
				}
			})
			setIsLoading(false)
		})
	}

	// First data is coming from the backend
	useEffect(() => {
		if (!isFirstRender.current) {
			setIsLoading(true)

			loadData(generateURL()).then(({ mainContent, search }) => {
				setResults({
					[tab]: mainContent,
				})
				setSearch(search)
				setIsLoading(false)
			})
		}
		isFirstRender.current = false
	}, [tab, page, generateURL, loadMore])

	return (
		<ResultContext.Provider
			value={{
				isLoading,
				handleLoadMoreResults,
				loadMore,
				tabs,
				results,
				search,
			}}
		>
			{children}
		</ResultContext.Provider>
	)
}
export default ResultProvider
